<template>
    <div :class="calculateModalClass" v-show="value">
        <div class="modal-dialog modal-dialog" role="document">
            <div :class="generateContentClass">
                <div class="jv-modal-header">
                    <h3 class="jv-modal-title">{{header}}</h3>
                    
                    <button type="button" class="close" @click.prevent="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <component :is="content" :data="data" @close="close()" @save="save"> </component>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import _ from 'lodash';

    export default {
        name: 'Modal',
        props: {
            value: {
                required: true
            },
            content: null,
            data: null,
            header: String,
            modalClass: String,
            contentClass: String
        },
        computed: {                
            calculateModalClass: function () {
                if (this.modalClass == null || this.modalClass == 'undefined')
                    return 'modal';
                if (this.modalClass == 'position-fixed')
                    return 'modal-position-fixed';
            },
            generateContentClass: function () {
                let contentClass = 'modal-content';
                if (this.contentClass == null || this.modalClass == 'undefined')
                    return contentClass;

                let modificators = this.contentClass.split(' ');
                if (_.includes(modificators, 'content-mt-50'))                
                    contentClass += ' modal-content-margin-top-50';

                if (_.includes(modificators, 'content-sm-modal'))
                    contentClass += ' modal-content-sm';

                if (_.includes(modificators, 'modal-content-lg'))
                    contentClass += ' modal-content-lg';

                if (_.includes(modificators, 'modal-content-xlg'))
                    contentClass += ' modal-content-xlg';

                return contentClass;
            }
                
        },
        //data() {
        //    return {
        //        header: null
        //    }
        //},
        methods: {
            close() {
                this.$emit("input", !this.value);
            },
            save(evt) {
                this.$emit("save", evt);
            }
        }
    }
</script>
<style scoped>
    .modal {
        background-color: rgba(0, 0, 0, 0.7);
    }

    .modal {
        top: 0;
        left: 0;
        z-index: 1050;
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        outline: 0;
        display: block;
    }

    .modal-position-fixed {
        background-color: rgba(0, 0, 0, 0.7);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1050;
        width: 100%;
        height: 100%;
        overflow: hidden;
        outline: 0;
        display: block;
    }

    .modal-content {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        pointer-events: auto;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 0.3rem;
        outline: 0;
        overflow: visible;
    }

    .modal-content-margin-top-50 {        
        margin-top: 50px;
    }

    .modal-content-sm {
        width: 30% !important;
        left: 35% !important;
        top: 35% !important;
    }

    .modal-content-lg {
        width: 115% !important;
        left: -8% !important;
    }

    .modal-content-xlg {
        width: 122% !important;
        left: -11% !important;
    }   

    .modal-dialog {
        max-width: 80%;
    }

    .modal-body{
        overflow: visible;
    }
</style>